import { Link } from 'react-router-dom';

export const PrivacyPolicy = () => {
  return (
    <div className="mx-auto max-w-3xl rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
      <h1 className="mb-4 text-2xl font-bold text-gray-900">Privacy Policy</h1>
      <p className="mb-6 text-sm font-semibold text-gray-700">
        Tandaulwadi Phone Book
        <br />
        Effective Date: 14/09/2026
      </p>

      <p className="mb-4 text-sm text-gray-700">
        Welcome to the <strong>Tandaulwadi Phone Book</strong>. This Privacy Policy explains how we collect, use, and protect information provided by users of our Phone Book service.
      </p>

      <p className="mb-4 text-sm text-gray-700">
        Our Phone Book is intended to help members of the <strong>Tandaulwadi village community</strong> find and connect with people from the village in a convenient and responsible manner.
      </p>

      <h2 className="mb-2 mt-6 text-lg font-semibold text-gray-900">1. Information We Collect</h2>
      <p className="mb-2 text-sm text-gray-700">To provide the Phone Book service, we may collect information such as:</p>
      <ul className="mb-4 list-inside list-disc space-y-1 text-sm text-gray-700">
        <li>Name</li>
        <li>Mobile number</li>
        <li>Email address, where applicable</li>
        <li>Information provided during registration</li>
        <li>Contact information submitted for inclusion in the Phone Book</li>
      </ul>
      <p className="mb-4 text-sm text-gray-700">We collect only information that is reasonably required to provide and maintain the service.</p>

      <h2 className="mb-2 mt-6 text-lg font-semibold text-gray-900">2. How We Use Your Information</h2>
      <p className="mb-2 text-sm text-gray-700">Information provided to the Tandaulwadi Phone Book may be used to:</p>
      <ul className="mb-4 list-inside list-disc space-y-1 text-sm text-gray-700">
        <li>Create and manage your account</li>
        <li>Maintain the village Phone Book</li>
        <li>Help registered users find contact information</li>
        <li>Keep contact information accurate and up to date</li>
        <li>Communicate with users regarding the service</li>
        <li>Maintain the security and proper functioning of the Phone Book</li>
      </ul>
      <p className="mb-4 text-sm text-gray-700">The primary purpose of collecting contact information is to provide the <strong>Tandaulwadi village Phone Book service</strong>.</p>

      <h2 className="mb-2 mt-6 text-lg font-semibold text-gray-900">3. Phone Book Information</h2>
      <p className="mb-4 text-sm text-gray-700">
        The Phone Book contains contact information intended to help members of the Tandaulwadi community communicate with one another. Phone Book information is made available only to users who are authorized to use the service. Users are expected to use phone numbers and other contact information responsibly and only for genuine communication purposes.
      </p>

      <h2 className="mb-2 mt-6 text-lg font-semibold text-gray-900">4. Registration</h2>
      <p className="mb-4 text-sm text-gray-700">
        Users may be required to provide basic information, including their name and mobile number, when registering for the Phone Book. By registering, you confirm that the information you provide is accurate to the best of your knowledge. You also agree to use the Phone Book responsibly and respect the privacy of other members of the community.
      </p>

      <h2 className="mb-2 mt-6 text-lg font-semibold text-gray-900">5. Information Accuracy</h2>
      <p className="mb-4 text-sm text-gray-700">
        We make reasonable efforts to maintain accurate and up-to-date information in the Phone Book. If you believe that your information is incorrect, outdated, or needs to be changed, you may contact us through the <Link to="/contact-us" className="font-medium text-blue-600 hover:text-blue-800">Contact Us</Link> page.
      </p>
      <p className="mb-4 text-sm text-gray-700">
        If you want your phone number removed from the Phone Book, please submit a{' '}
        <Link to="/request-removal" className="font-medium text-blue-600 hover:text-blue-800">
          removal request
        </Link>
        . We will process it within 5 to 7 working days.
      </p>

      <h2 className="mb-2 mt-6 text-lg font-semibold text-gray-900">6. Protection of Information</h2>
      <p className="mb-4 text-sm text-gray-700">
        We take reasonable measures to protect the information provided to the Phone Book from unauthorized access, alteration, disclosure, or misuse. However, no online service can guarantee complete security of information.
      </p>

      <h2 className="mb-2 mt-6 text-lg font-semibold text-gray-900">7. Sharing of Information</h2>
      <p className="mb-4 text-sm text-gray-700">
        We do not intend to sell, rent, or commercially distribute personal information collected through the Tandaulwadi Phone Book. Information may be disclosed when required by applicable law or when necessary to protect the security and integrity of the service.
      </p>

      <h2 className="mb-2 mt-6 text-lg font-semibold text-gray-900">8. Responsible Use</h2>
      <p className="mb-2 text-sm text-gray-700">Users must not use information obtained from the Phone Book for:</p>
      <ul className="mb-4 list-inside list-disc space-y-1 text-sm text-gray-700">
        <li>Spam or unwanted communication</li>
        <li>Harassment or intimidation</li>
        <li>Fraudulent activities</li>
        <li>Unauthorized commercial purposes</li>
        <li>Any unlawful activity</li>
      </ul>
      <p className="mb-4 text-sm text-gray-700">Please respect the privacy and preferences of fellow members of the Tandaulwadi community.</p>

      <h2 className="mb-2 mt-6 text-lg font-semibold text-gray-900">9. Children's Privacy</h2>
      <p className="mb-4 text-sm text-gray-700">
        The Phone Book is intended for general community use. We do not knowingly collect personal information from children without appropriate permission.
      </p>

      <h2 className="mb-2 mt-6 text-lg font-semibold text-gray-900">10. Changes to This Privacy Policy</h2>
      <p className="mb-4 text-sm text-gray-700">
        We may update this Privacy Policy from time to time to reflect changes to the service or applicable requirements. Any updated policy will be published on this page.
      </p>

      <h2 className="mb-2 mt-6 text-lg font-semibold text-gray-900">11. Contact Us</h2>
      <p className="mb-4 text-sm text-gray-700">
        If you have any questions, concerns, or requests regarding your information or this Privacy Policy, please contact us through the{' '}
        <Link to="/contact-us" className="font-medium text-blue-600 hover:text-blue-800">Contact Us</Link> page.
      </p>

      <p className="mb-4 text-sm text-gray-700">
        We appreciate your trust and cooperation in keeping the Tandaulwadi Phone Book useful, safe, and respectful for the entire village community.
      </p>

      <p className="mt-6 border-t border-gray-200 pt-4 text-center text-sm font-semibold text-gray-700">
        Tandaulwadi Phone Book ®
        <br />
        All Rights Reserved by TK
      </p>
    </div>
  );
};
